import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import DiscountUserSearchInput from './DiscountUserSearchInput';

/**
 * Спільна форма застосування знижки: рівень / % / клієнт.
 * Якщо передано onApply — кнопка «Застосувати» в рядку з пошуком (checkout).
 * У модалці onApply не передають: Apply лишається в footer.
 */
const AdminDiscountForm = ({
  forceDiscount,
  onForceDiscountChange,
  discountLevelsList = [],
  selectedDiscountLevel,
  onDiscountLevelChange,
  discountPercent,
  onDiscountPercentChange,
  token,
  selectedUser,
  userSearchQuery,
  onUserSearchQueryChange,
  onUserSelect,
  onUserClear,
  disabled = false,
  forceCheckboxId = 'adminForceDiscount',
  forceCheckClassName = '',
  onApply,
  applyLabel = 'Застосувати',
}) => {
  const showInlineApply = typeof onApply === 'function';

  return (
    <>
      <div className={`form-check d-flex align-items-center pl-0 mb-2 ${forceCheckClassName}`.trim()}>
        <input
          type="checkbox"
          className="form-check-input m-0"
          id={forceCheckboxId}
          checked={forceDiscount}
          onChange={onForceDiscountChange}
          disabled={disabled}
          style={{ width: '1rem', height: '1rem', position: 'static', cursor: 'pointer' }}
        />
        <label className="form-check-label ml-2 mb-0" htmlFor={forceCheckboxId} style={{ cursor: 'pointer' }}>
          Дозволити збільшити вартість
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`${forceCheckboxId}-tooltip`}>
                При перерахунку вартість зі знижкою може бути збільшена
              </Tooltip>
            }
          >
            <i className="bi bi-info-circle ml-1" style={{ fontSize: '0.9em' }} />
          </OverlayTrigger>
        </label>
      </div>

      <div className="row mb-2">
        <div className={showInlineApply ? 'col-12 col-md-8 mb-1 mb-md-0' : 'col-8'}>
          <select
            className="form-control"
            value={selectedDiscountLevel}
            onChange={onDiscountLevelChange}
            disabled={disabled}
          >
            <option value="">Рівень знижки</option>
            {discountLevelsList.map((l) => (
              <option key={l.level} value={l.level}>
                {l.level} - {l.levelName || ''}
              </option>
            ))}
          </select>
        </div>
        <div className={showInlineApply ? 'col-12 col-md-4' : 'col-4'}>
          <input
            type="text"
            className="form-control"
            name="discountPercent"
            placeholder="% знижки"
            value={discountPercent}
            onChange={onDiscountPercentChange}
            disabled={disabled}
          />
        </div>
      </div>

      <div className={showInlineApply ? 'row' : undefined}>
        <div className={showInlineApply ? 'col-12 col-md-8 mb-1 mb-md-0' : undefined}>
          <DiscountUserSearchInput
            token={token}
            selectedUser={selectedUser}
            searchQuery={userSearchQuery}
            onSearchQueryChange={onUserSearchQueryChange}
            onSelect={onUserSelect}
            onClear={onUserClear}
            disabled={disabled}
            placeholder="Клієнт (телефон, прізвище, email)"
          />
        </div>
        {showInlineApply && (
          <div className="col-12 col-md-4">
            <button
              type="button"
              className="btn btn-dark btn-block d-none d-md-block"
              disabled={disabled}
              onClick={onApply}
            >
              {applyLabel}
            </button>
            <button
              type="button"
              className="btn btn-dark btn-sm btn-block d-md-none"
              disabled={disabled}
              onClick={onApply}
            >
              {applyLabel}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminDiscountForm;
